interface PostDateIntervalEnabledBadge {
  postDateIntervalEnabled: boolean;
}

export const usePostDateIntervalEnabledBadge = ({ postDateIntervalEnabled }: PostDateIntervalEnabledBadge) => {
  return {
    postDateIntervalEnabledBadgeProps: {
      data: [{
        value: postDateIntervalEnabled?.toString() || 'false',
        label: postDateIntervalEnabled ? 'Post Date' : 'Insight Date'
      }],
    }
  };
};
